import SwiperLib from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
const $ = jQuery.noConflict();
SwiperLib.use([Navigation, Pagination]);
class Swiper {
	constructor() {
		this.component = $('.swiper-slider-component');
	}
	init() {
		this.swiper();
	}
	swiper() {
		if (this.component.length) {
			this.component.each(function () {
				const $this = $(this);
				const options = $this.data('swiper');

				if (!options) {
					// eslint-disable-next-line no-console
					console.warn('No Swiper options found on', $this);
					return;
				}

				new SwiperLib($this[0], options);
			});
		}
	}
}
const swiperSlider = new Swiper();
// GLOBAL APP CONTROLLER
const controller = {
	init() {
		swiperSlider.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
